import type { Vec3 } from "../math.ts";

/** Transient happenings sent to clients for VFX/SFX/feedback. Net ids, not entity ids. */
export type SimEvent = { id?: number; tick?: number } & (
  | { type: "tracer"; owner: number; from: Vec3; to: Vec3; kind: number }
  | { type: "impact"; pos: Vec3; kind: number }
  | { type: "explosion"; pos: Vec3; radius: number; kind: number }
  | { type: "damage"; attacker: number; target: number; amount: number; crit: boolean; pos: Vec3 }
  | { type: "heal"; healer: number; target: number; amount: number }
  /**
   * `killer` landed the final hit. `kos` are the other players who share the KO (damaged the
   * victim recently); `assists` enabled it without a KO (healed or buffed a KO-getter, or
   * crowd-controlled the victim). Marvel Rivals rules.
   */
  | { type: "kill"; killer: number; victim: number; killerHero: number; victimHero: number; kos: number[]; assists: number[] }
  | { type: "cast"; owner: number; slot: number; hero: number }
  | { type: "form"; target: number; hero: number; form: number }
  | { type: "pickup"; pos: Vec3; large: boolean }
  | { type: "revive"; target: number }
);

export type SimEventType = SimEvent["type"];

export enum FxKind {
  Rifle = 0,
  Rocket = 1,
  Pellet = 2,
  Pistol = 3,
  Grenade = 4,
  Spore = 5,
  Hammer = 6,
  Concussion = 7,
  Hook = 8,
  Missile = 9,
  Dart = 10,
  Shockwave = 11,
  Quake = 12,
  Singularity = 13,
  Charge = 14,
}
